module.exports = __webpack_public_path__ + "img/wallet.2a700f29.svg";